export async function sha256ToHexString(data: string): Promise<string> {
  // Convert input string to bytes
  const bytes = new TextEncoder().encode(data);

  // Generate SHA-256 hash
  const hashBuffer = await crypto.subtle.digest("SHA-256", bytes);

  // Convert hash buffer to hex string
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}
